import { Component, OnInit } from '@angular/core';
import { faCode } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { Language } from 'src/app/core/enums/language.enum';
import { PraticaIndexItem } from 'src/app/components/pratica/pratica-index/pratica-index.component';
import { InteractionService } from 'src/app/core/services/interaction.service';
import { TestModalComponent } from 'src/app/components/modals/test-modal/test-modal.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    faCode = faCode;
    readonly LANGUAGE = Language;
    linkList: PraticaIndexItem[];
    datasource = [
        {position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H'},
        {position: 2, name: 'Helium', weight: 4.0026, symbol: 'He'},
        {position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li'},
        {position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be'},
        {position: 5, name: 'Boron', weight: 10.811, symbol: 'B'},
        {position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C'},
        {position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N'},
        {position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O'},
        {position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F'},
        {position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne'},
    ];
    displayedColumns: string[] = ['position', 'name', 'weight', 'symbol'];

    constructor(
        private readonly translateService: TranslateService,
        private readonly interactionService: InteractionService
    ) {
        translateService.setDefaultLang(Language.IT);
        translateService.use(Language.IT);
    }

    showModal() {
        this.interactionService.showModal(TestModalComponent);
    }

    ngOnInit(): void {
        this.linkList = [];
        const item = new PraticaIndexItem();
        item.label = 'test 1';
        item.childs = [];
        const child1 = new PraticaIndexItem();
        child1.label = 'test 1.1';
        const child2 = new PraticaIndexItem();
        child2.label = 'test 1.2';
        const child3 = new PraticaIndexItem();
        child3.label = 'test 1.3';
        item.childs.push(child1);
        item.childs.push(child2);
        item.childs.push(child3);
        this.linkList.push(item);
    }

}
